<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="机构" required prop="institutionCode">
                <el-select v-model="addForm.institutionCode" @change="ins_change" placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="残疾人" required prop="elderlyName">
                <el-input v-model="addForm.elderlyName" placeholder="选择残疾人" disabled style="">
                  <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                  <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="护理人员类型">
                <el-select v-model="person_type" @change="person_types_change" style="width: 100%">
                  <el-option
                      v-for="item in person_types"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="护理人员" required prop="userCode">
                <el-select v-model="addForm.userCode" style="width: 100%">
                  <el-option
                      v-for="item in arr_persons"
                      :key="item.userCode"
                      :label="item.name"
                      :value="item.userCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24" class="item">
              <el-table class="table" size="mini" :data="items"
                        :height="200" border >

                <el-table-column type="expand" v-if="items.length">
                  <template slot-scope="props">
                    <el-form>
                      <el-form-item label="早餐用药：" v-if="props.row.medicationSchedulingMorningDTO.medicationSchedulingMorningItemList.length >0 ">
                        <el-tag v-for="(value,i) in props.row.medicationSchedulingMorningDTO.medicationSchedulingMorningItemList" :key="i" style="margin-right: 5px">{{value.medicationGroupName}}</el-tag>

                        <el-button @click="yy(props.row.medicationSchedulingMorningDTO.medicationSchedulingCode,props.row.medicationSchedulingMorningDTO.medicationSchedulingMorningCode,'','')"
                                   style="float: right;" type="danger" size="mini" v-if="props.row.medicationSchedulingMorningDTO.hadUse == false">早餐用药</el-button>
                      </el-form-item>
                      <el-form-item label="中午用药：" v-if="props.row.medicationSchedulingNoonDTO.medicationSchedulingNoonItemList.length >0 ">
                        <el-tag v-for="(value,i) in props.row.medicationSchedulingNoonDTO.medicationSchedulingNoonItemList" :key="i" style="margin-right: 5px">{{value.medicationGroupName}}</el-tag>

                        <el-button @click="yy(props.row.medicationSchedulingNoonDTO.medicationSchedulingCode,'',props.row.medicationSchedulingNoonDTO.medicationSchedulingNoonCode,'')"
                                   style="float: right;" type="danger" size="mini" v-if="props.row.medicationSchedulingNoonDTO.hadUse == false">中午用药</el-button>
                      </el-form-item>
                      <el-form-item label="晚上用药：" v-if="props.row.medicationSchedulingNightDTO.medicationSchedulingNightItemList.length >0 ">
                        <el-tag v-for="(value,i) in props.row.medicationSchedulingNightDTO.medicationSchedulingNightItemList" :key="i" style="margin-right: 5px">{{value.medicationGroupName}}</el-tag>

                        <el-button @click="yy(props.row.medicationSchedulingNightDTO.medicationSchedulingCode,'','',props.row.medicationSchedulingNightDTO.medicationSchedulingNightCode)"
                                   style="float: right;" type="danger" size="mini" v-if="props.row.medicationSchedulingNightDTO.hadUse == false">晚上用药</el-button>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-table-column>

                <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>
                <el-table-column prop="day" label="星期"></el-table-column>
                <el-table-column prop="time" :formatter="formatTime" label="用药日期"></el-table-column>


              </el-table>

            </el-col>



          </el-row>


        </el-form>

      </div>
<!--      <div class="modal-footer">-->
<!--        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>-->
<!--      </div>-->
    </div>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>


  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Elderly from "@/views/Elderly/Comm/ElderlyInsCheckIn3";


export default {
  name: 'Add',
  props:['arr_ins'],
  data() {
    return {

      loading: false,
      showModalGetElderly:false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        institutionCode:'',

        elderlyCode:'',
        elderlyName:'',
        elderlyUserCode:'',

        userCode:'',

        medicationSchedulingCode:'',
        medicationSchedulingMorningCode:'',
        medicationSchedulingNoonCode:'',
        medicationSchedulingNightCode:'',


      },



      person_types: [
        {value: 1, label: '医生'},
        {value: 2, label: '护士'},
        {value: 3, label: '护工'}
      ],
      person_type:'',

      arr_persons:[],

      items:[],



      rules:{
        startTime:[
          { required: true, message: '请选择开始时间', trigger: 'blur' },
        ],
        endTime:[
          { required: true, message: '请选择结束时间', trigger: 'blur' },
        ],
        institutionCode:[
          { required: true, message: '请选择机构', trigger: 'blur' },
        ],
        elderlyName:[
          { required: true, message: '请选择老人', trigger: 'blur' },
          { required: true, message: '请选择老人', trigger: 'change' },
        ],
        itemCodeArr:[
          { required: true, message: '请选择护理项目', trigger: 'blur' },
        ],
        userCode:[
          { required: true, message: '请选择护理人员', trigger: 'blur' },
        ],


      },

      type:'',




    }
  },
  components:{
    Elderly
  },
  methods: {
    init(type){
      this.type = type;
      this.$refs.addForm.resetFields();

    },
    closeSelf() {
      this.$emit("closeAdd");
    },




    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init(this.type,this.addForm.institutionCode);
    },
    setElderly(row){
      this.addForm.elderlyCode = row.elderlyCode;
      this.addForm.elderlyName = row.name;
      this.addForm.elderlyUserCode = row.userCode;

      this.getItem();
    },
    clearElderly(){
      this.addForm.elderlyCode = '';
      this.addForm.elderlyName = '';
      this.addForm.elderlyUserCode = '';
    },


    ins_change(val){
      this.addForm.institutionCode = val;

      this.addForm.elderlyCode = '';
      this.addForm.elderlyName = '';
      this.addForm.elderlyUserCode = '';

      this.person_type='';

      this.arr_persons = [];
      this.addForm.userCode = '';
    },

    person_types_change(val){
      this.person_type = val;

      this.addForm.userCode='';
      this.arr_persons = [];
      this.getPerson(this.person_type);
    },
    getPerson(type){

      let url = "";
      if(type == 1){
        url = this.$shopUrl+"Mediciner/InsListNormal";
      }
      if(type == 2){
        url = this.$shopUrl+"Nurse/InsListNormal";
      }
      if(type == 3){
        url = this.$shopUrl+"NurseAide/InsListNormal";
      }

      this.$axios({
        method: 'post',
        url: url,
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          institutionCode: this.addForm.institutionCode,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_persons = response.data.data.list;

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    formatTime:function (row, column, cellValue) {
      return timefilters(cellValue).substring(0,10);
    },
    timefilter2(cellValue) {
      return timefilters(cellValue)
    },

    getItem(){

      let now = new Date();
      now.setDate(now.getDate() - 3);
      let before = now;

      let now2 = new Date();
      now2.setDate(now2.getDate() + 3);
      let end = now2;

      //end = new Date(end.getTime() + 1000 * 60 * 60 * 8);


      this.$axios({
        method: 'post',
        url:this.$shopUrl+"MedicationScheduling/ElderlyList3",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
          elderlyCode: this.addForm.elderlyCode,
          startTime:this.timefilter2(before),
          endTime:this.timefilter2(end),
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.items = response.data.data.list;

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },



    yy(medicationSchedulingCode,medicationSchedulingMorningCode,medicationSchedulingNoonCode,medicationSchedulingNightCode){

      this.$refs['addForm'].validate((valid) => {
        if(valid){
          this.addSubmit(medicationSchedulingCode,medicationSchedulingMorningCode,medicationSchedulingNoonCode,medicationSchedulingNightCode);
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },


    addSubmit(medicationSchedulingCode,medicationSchedulingMorningCode,medicationSchedulingNoonCode,medicationSchedulingNightCode){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }
      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.addForm.medicationSchedulingCode = medicationSchedulingCode;
      this.addForm.medicationSchedulingMorningCode = medicationSchedulingMorningCode;
      this.addForm.medicationSchedulingNoonCode = medicationSchedulingNoonCode;
      this.addForm.medicationSchedulingNightCode = medicationSchedulingNightCode;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicationRecord/Add",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>

<style lang="scss" scoped>


</style>
